module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "scheduled-events text-dark"
  }, [_c('h2', {
    staticClass: "marg-5-bottom"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].scheduled_events) + " \"" + _vm._s(_vm.subject.name) + "\"")]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#f6f9fc"
    }
  }) : _c('div', [(_vm.sortedEvents.length < 1) ? _c('p', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.i18n[_vm.locale].no_scheduled_events))]) : _c('table', {
    staticClass: "scheduled-events__table"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].date))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].weekday))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].time))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.i18n[_vm.locale].calendars))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.sortedEvents), function(event) {
    return _c('tr', {
      key: event.event_id
    }, [_c('td', [_c('span', {
      staticClass: "subject-event",
      style: ({
        'backgroundColor': _vm.subject.color
      })
    }, [_vm._v(_vm._s(event.v_date))])]), _vm._v(" "), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(event.v_weekday))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(event.v_time))]), _vm._v(" "), _c('td', {
      staticClass: "text-greyed"
    }, [_vm._v(_vm._s(event.v_calendars))])])
  }), 0)]), _vm._v(" "), (_vm.sortedEvents.length > 0) ? _c('p', {
    staticClass: "scheduled-events__count"
  }, [_vm._v("\n      " + _vm._s(_vm.sortedEvents.length) + " " + _vm._s(_vm.i18n[_vm.locale].events_total) + "\n    ")]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9d87c752!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subjects/SubjectFormScheduledEvents.vue
// module id = 2068
// module chunks = 1